module.exports = __webpack_public_path__ + "static/media/claimStatus.4334fb65.svg";